export type LandingView =
  | 'landing'
  | 'landing_features'
  | 'landing_pricing'
  | 'landing_it_services'
  | 'landing_solutions'
  | 'landing_matjaar'
  | 'landing_contact'
  | 'landing_case_studies'
  | 'landing_blog';

export type AppView = LandingView | 'not_found';


export interface RouteMeta {
  view: LandingView;
  path: string;
  title: string;
  titleAr?: string;
  description: string;
  descriptionAr?: string;
  keywords: string;
}

export const SITE_URL = 'https://vye.onl';
export const SOCIAL_IMAGE = '/logo.webp?v=3';

export const landingRoutes: RouteMeta[] = [
  {
    view: 'landing',
    path: '/',
    title: 'VYE: Best IT Solutions Company & Software Development in Egypt',
    titleAr: 'VYE: شركة الحلول التقنية وتطوير البرمجيات الرائدة في مصر',
    description:
      'VYE provides next-gen enterprise IT solutions in Egypt, specializing in cloud services, custom software development, cybersecurity, and digital transformation.',
    descriptionAr:
      'تقدم VYE أحدث حلول تكنولوجيا المعلومات للشركات في مصر، وتتخصص في خدمات السحابة وتطوير البرمجيات المخصصة والأمن السيبراني والتحول الرقمي.',
    keywords:
      'best IT solutions company Egypt, cybersecurity services for SMEs Egypt, hybrid cloud solutions Egypt, cloud services Egypt, custom software development Egypt, enterprise IT solutions Egypt, managed IT services Egypt, next-gen technology Egypt',
  },
  {
    view: 'landing_features',
    path: '/expertise',
    title: 'VYE Expertise: Vue.js, Node.js, Cloud & Cybersecurity in Cairo, Egypt',
    titleAr: 'خبرات VYE: تطوير Vue.js و Node.js، السحابة والأمن السيبراني في القاهرة، مصر',
    description:
      "Explore VYE's expertise in custom Vue.js and Node.js software development, digital transformation, cloud computing, cybersecurity, and enterprise IT consulting in Cairo, Egypt.",
    descriptionAr:
      'استكشف خبرات شركة VYE في تطوير برمجيات Vue.js و Node.js المخصصة، التحول الرقمي، الحوسبة السحابية، الأمن السيبراني، واستشارات تكنولوجيا المعلومات للشركات في القاهرة، مصر.',
    keywords:
      'Vue.js development agency Cairo, Node.js development Egypt, software development company Egypt, IT consulting Egypt, business automation solutions, cybersecurity services Egypt, enterprise technology expertise',
  },
  {
    view: 'landing_pricing',
    path: '/engagement',
    title: 'VYE Engagement Models: Dedicated Teams & Product Delivery',
    titleAr: 'نماذج التعاقد مع VYE: فرق عمل مخصصة وتسليم المشاريع المتكاملة',
    description:
      'Discover VYE engagement models for full-project delivery, dedicated development teams, and ready SaaS products designed for scalable business growth.',
    descriptionAr:
      'اكتشف نماذج التعاقد المرنة من VYE بما في ذلك تسليم المشاريع المتكاملة، فرق التطوير المخصصة، والبرمجيات كخدمة (SaaS) المصممة لنمو الأعمال.',
    keywords:
      'dedicated development teams Egypt, technology partnership Egypt, SaaS products Egypt, project delivery, software outsourcing Egypt',
  },
  {
    view: 'landing_it_services',
    path: '/it-services',
    title: 'VYE IT Services Cairo: Managed IT, Cloud & Cybersecurity Solutions',
    titleAr: 'خدمات VYE لتكنولوجيا المعلومات بالقاهرة: حلول السحابة والأمن السيبراني',
    description:
      'VYE delivers enterprise IT services in Cairo, Egypt, including managed IT services, cloud computing solutions, digital transformation, and advanced cybersecurity services.',
    descriptionAr:
      'تقدم شركة VYE خدمات تكنولوجيا المعلومات للمؤسسات في القاهرة، مصر، بما في ذلك الخدمات المدارة، حلول الحوسبة السحابية، التحول الرقمي، والأمن السيبراني المتقدم.',
    keywords:
      'IT services Cairo, managed IT services Egypt, cloud computing solutions Egypt, enterprise IT solutions, digital transformation services Cairo',
  },
  {
    view: 'landing_contact',
    path: '/contact',
    title: 'Contact VYE: Enterprise IT Solutions in Egypt',
    titleAr: 'اتصل بنا - VYE: حلول تكنولوجيا المعلومات للشركات في مصر',
    description:
      'Contact VYE Technology Solutions for enterprise IT services, cloud consulting, cybersecurity, and custom software development in Egypt.',
    descriptionAr:
      'تواصل مع شركة VYE للحلول التقنية للحصول على خدمات تكنولوجيا المعلومات، استشارات السحابة، الأمن السيبراني، وتطوير البرمجيات في مصر.',
    keywords:
      'contact VYE Egypt, enterprise IT consultation Egypt, technology solutions Egypt, custom software consultation',
  },
  {
    view: 'landing_solutions',
    path: '/solutions',
    title: 'VYE Solutions: Advanced E-commerce and Enterprise Software Platforms',
    titleAr: 'حلول VYE: منصات التجارة الإلكترونية وبرمجيات الشركات المتقدمة',
    description:
      'Explore VYE software solutions and digital platforms, featuring Matjaar Cloud Platform and high-end enterprise automation suites designed for growth.',
    descriptionAr:
      'استكشف حلول VYE البرمجية والمنصات الرقمية، بما في ذلك منصة متجر السحابية وبوابات أتمتة الأعمال المصممة لنمو الشركات والتجارة في مصر.',
    keywords:
      'VYE solutions, Matjaar cloud, e-commerce platform Egypt, business automation portal, SaaS solutions Egypt, VYE software',
  },
  {
    view: 'landing_matjaar',
    path: '/matjaar',
    title: 'Matjaar Cloud Platform | B2B & B2C E-Commerce Solution in Egypt',
    titleAr: 'منصة متجر السحابية | حلول التجارة الإلكترونية الشاملة في مصر',
    description:
      'Launch your B2B/B2C e-commerce operations with Matjaar Cloud Platform. Enjoy local payment integrations, inventory sync, and enterprise scale.',
    descriptionAr:
      'أطلق متجرك الإلكتروني الشامل مع منصة متجر السحابية. تمتع بربط بوابات الدفع المحلية، تزامن المخزون، وقابلية التوسع للشركات الكبرى.',
    keywords: 'matjaar cloud, e-commerce platform egypt, b2b e-commerce egypt, online store builder',
  },
  {
    view: 'landing_case_studies',
    path: '/case-studies',
    title: 'VYE Case Studies: Proven Success Stories in Egypt',
    titleAr: 'نماذج العمل وقصص النجاح لشركة VYE في السوق المصري',
    description:
      'Read VYE technology case studies and success stories in retail automation, logistics digital transformation, and medical system development in Egypt.',
    descriptionAr:
      'اقرأ عن نماذج العمل وقصص نجاح VYE التقنية في أتمتة مبيعات التجزئة، التحول الرقمي للوجستيات، وتطوير الأنظمة الطبية في مصر.',
    keywords:
      'VYE case studies, IT success stories Egypt, digital transformation cases, retail automation case study, medical system development Egypt',
  },
  {
    view: 'landing_blog',
    path: '/blog',
    title: 'VYE Tech Blog: Digital Transformation & SaaS Insights in Egypt',
    titleAr: 'المدونة التقنية لـ VYE: مقالات ورؤى التحول الرقمي و SaaS في مصر',
    description:
      'Explore the latest tech trends, digital transformation tips, and comparison studies on Cloud solutions and SaaS in the Egyptian market.',
    descriptionAr:
      'استكشف أحدث التوجهات التقنية، ونصائح التحول الرقمي، ودراسات مقارنة حول الحلول السحابية و SaaS في السوق المصري.',
    keywords:
      'VYE tech blog, digital transformation egypt, IT blog Egypt, SaaS insights Cairo, cloud services blog',
  },
];

export const landingViews = landingRoutes.map((route) => route.view);

export const pathToLandingView = new Map(landingRoutes.map((route) => [route.path, route.view]));
export const landingViewToPath = new Map(landingRoutes.map((route) => [route.view, route.path]));
export const routeMetaByView = new Map(landingRoutes.map((route) => [route.view, route]));

export function isLandingView(view: string | null): view is LandingView {
  return Boolean(view && landingViews.includes(view as LandingView));
}

export function normalizePath(pathname: string) {
  if (pathname.length > 1 && pathname.endsWith('/')) {
    return pathname.slice(0, -1);
  }

  return pathname || '/';
}

export function mapPathToView(path: string): AppView {
  let cleanPath = normalizePath(path);
  if (cleanPath === '/en') {
    cleanPath = '/';
  } else if (cleanPath.startsWith('/en/')) {
    cleanPath = cleanPath.substring(3);
  }
  
  if (cleanPath.startsWith('/blog/')) {
    return 'landing_blog';
  }
  
  return pathToLandingView.get(cleanPath) || 'not_found';
}

